<template>
  <div class="monitorlogmanagement">
    <el-row>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          v-for="(item, index) in tabsList"
          :label="item.name"
          :value="item.name"
          :key="index"
        >
          <el-row class="row-title" style="display: flex;">
              <!-- <kt-button label="添加" type="primary" @click="handleAdd" /> -->
              <p style="line-height: 34px; font-size:18px;margin-left:20px;margin-right:10px">选择日期:</p>
            <el-col :span="8">
              
              <el-date-picker
                :editable="false"
                :clearable="true"
                v-model="datatime"
                type="date"
                :placeholder="monitorManager.choseDate"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                @change="filterList"
              ></el-date-picker>
            </el-col>

            <el-col :span="4">
              <el-button
                  type="info"
                  @click="exportExcel"
                  icon="el-icon-download"
                  plain>记录导出</el-button>
            </el-col>
            
          </el-row>
          <el-row>
            <!--表格内容栏-->
            <el-table
              :data="filterColumns"
              border
              style="width: 100%; margin-top: 10px"
              :row-style="tableRowStyle"
              :header-cell-style="tableHeaderColor"
              :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
            >
              <el-table-column
                prop="oldName"
                :label="monitorManager.name"
                width="130"
              ></el-table-column>
              <el-table-column
                prop="date"
                label="日期"
                width="130"
              ></el-table-column>
              <el-table-column
                prop="period"
                :label="monitorManager.time"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="place"
                :label="monitorManager.place"
                width="180"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="event"
                :label="monitorManager.event"
              ></el-table-column>
              <el-table-column
                prop="reason"
                :label="monitorManager.reason"
              ></el-table-column>
              <el-table-column
                prop="handle"
                :label="monitorManager.handle"
              ></el-table-column>
              <!-- <el-table-column :label="monitorManager.operation">
                <template slot-scope="scope">
                  <a class="curcor" @click="fixLog(scope.row)">
                    <img src="@/assets/beadhouse/xiugai_icon_1.png" />
                  </a>
                  <a class="curcor" @click="deleList(scope.row)">
                    <img src="@/assets/beadhouse/shanchu_icon.png" />
                  </a>
                </template>
              </el-table-column> -->
              <el-table-column
                prop="userName"
                :label="monitorManager.userName"
              ></el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
        <el-pagination
          class="center-pg fenye"
          ref="pagination"
          background
          @current-change="handleCurrentChange"
          :page-size="10"
          layout="total, prev, pager, next"
          align="center"
          :total="total"
        ></el-pagination>
      </el-tabs>
    </el-row>
    <!-- 添加班长日志和修改班长日志的dialog模态框-->
    <el-dialog
      class="monitorLogdialog"
      title="修改日志"
      width="40%"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="dataForm"
        label-width="100px"
        :rules="dataFormRules"
        ref="dataForm"
        label-position="right"
      >
        <el-row>
          <el-col :span="10">
            <el-form-item :label="monitorManager.name + ':'" prop="oldName">
              <el-input v-model="dataForm.oldName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item :label="monitorManager.time + ':'" prop="date">
              <el-date-picker
                :editable="false"
                :clearable="false"
                v-model="dataForm.date"
                type="date"
                style="width: 90%"
                :placeholder="monitorManager.choseDate"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item
              :label="monitorManager.userName + ':'"
              prop="responsibilityMan"
            >
              <el-autocomplete
                v-model.trim="dataForm.responsibilityMan"
                auto-complete="off"
                :placeholder="monitorManager.placeHolder"
                style="width: 100%"
                :fetch-suggestions="querynurse"
                @select="SelectNurse"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item
              :label="monitorManager.timeHorizon"
              prop="timeHorizon"
            >
              <el-time-picker
                :editable="false"
                :clearable="false"
                is-range
                style="width: 90%"
                v-model="dataForm.timeHorizon"
                :range-separator="monitorManager.to"
                :start-placeholder="monitorManager.timeStart"
                :end-placeholder="monitorManager.timeover"
                :placeholder="monitorManager.choseTime"
                value-format="HH:mm:ss"
                format="HH:mm:ss"
              ></el-time-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="monitorManager.place + ':'" prop="site">
          <el-input
            v-model.trim="dataForm.site"
            type="textarea"
            :rows="2"
            auto-complete="off"
            placeholder
            style="width: 95%"
          ></el-input>
        </el-form-item>
        <el-form-item :label="monitorManager.event + ':'" prop="occurrence">
          <el-input
            v-model.trim="dataForm.occurrence"
            type="textarea"
            :rows="3"
            auto-complete="off"
            placeholder
            style="width: 95%"
          ></el-input>
        </el-form-item>
        <el-form-item :label="monitorManager.reason + ':'" prop="reason">
          <el-input
            v-model.trim="dataForm.reason"
            type="textarea"
            :rows="3"
            auto-complete="off"
            placeholder
            style="width: 95%"
          ></el-input>
        </el-form-item>
        <el-form-item :label="monitorManager.handle + ':'" prop="howToHandle">
          <el-input
            v-model.trim="dataForm.howToHandle"
            type="textarea"
            :rows="3"
            auto-complete="off"
            placeholder
            style="width: 95%"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click.native="dialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="submitForm"
          :loading="dataFormLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
import { baseURL } from "@/utils/request.js";
import util from "@/utils/util.js";
export default {
  name: "MonitorLogManagement",
  components: { KtTable, KtButton },
  data() {
    return {
      monitorManager: {
        lastDay: "上一天",
        nextDay: "下一天",
        name: "姓名",
        time: "时间",
        place: "地点",
        event: "发生事件",
        reason: "原因",
        handle: "如何处理",
        operation: "操作",
        userName: "负责人",
        addMonitor: "添加班长日志",
        fixMonitor: "修改班长日志",
        placeHolder: "请选择",
        placeChose: "选择时间",
        timeHorizon: "时间范围",
        to: "至",
        timeStart: "开始时间",
        timeOver: "结束时间",
        choseTime: "请选择时间范围",
        place: "地点",
        choseDate: "选择日期"
      }, //引入中文字符
      loading: true,
      groupId: "", //护士组id
      datatime: "",
      activeName: "",
      tabsList: [],
      //dialog的配置
      operation: true,
      dialogVisible: false,
      dataForm: {
        oldName: "",
        period: "",
        place: "",
        responsibilityMan: "", //负责人
        timeHorizon: "", //时间范围
        site: "", //地点
        occurrence: "", //事件
        reason: "", //原因
        howToHandle: "", //如何处理
      },
      dataFormRules: {
        oldName: [
          { required: true, message: "不能为空", trigger: "blur" }, //是否必填 //规则  //何事件触发
        ],
        date: [{ required: true, message: "不能为空", trigger: "change" }],
        responsibilityMan: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
        timeHorizon: [
          { required: true, message: "不能为空", trigger: "change" },
        ],
        site: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 32, message: "长度在 1到 32 个字符" },
        ],
        occurrence: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 256, message: "长度在 1到 256 个字符" },
        ],
        reason: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 256, message: "长度在 1到 256 个字符" },
        ],
        howToHandle: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 256, message: "长度在 1到 256 个字符" },
        ],
      },
      dataFormLoading: false,
      dataFormLoading: false,
      nurseList: [], //护工信息
      oldList: [], //老人信息
      oldManId: "", //老人id
      userId: "", //负责人id
      fixLogid: 0, //修改当前列的id
      filterColumns: [], //表格数据
      pageNum: 1,
      pageSize: 10,
      total: 0, //分页总数
    };
  },
  methods: {
    /* 
            修改table tr行的背景色
        */
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },

    /* 
            修改table header的背景色
        */
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
    //上一天
    handlePrevDay() {
      // 获得当前日期
      var doday = new Date(this.datatime);
      doday = Date.parse(doday);
      // 将当前日期减去1天的时间
      doday = doday - 1000 * 60 * 60 * 24;
      // timeFormat()日期格式化
      var nowDate = util.formatDate.format(new Date(doday));
      // 获得value
      this.datatime = nowDate;
      this.findPage();
    },

    //下一天
    handleNextDay() {
      // 获得当前日期
      var doday = new Date(this.datatime);
      doday = Date.parse(doday);
      // 将当前日期加上1天的时间
      doday = doday + 1000 * 60 * 60 * 24;
      // timeFormat()日期格式化
      var nowDate = util.formatDate.format(new Date(doday));
      // 获得value
      this.datatime = nowDate;
      this.findPage();
    },

    //导出
    exportExcel() {
      window.location.href =
      baseURL +
      `omc/api/downMonitorLogTableExcel?groupId=${window.sessionStorage.getItem("groupId")}`;
    },
    //根据时间查询表格数据
    filterList(val) {
      this.dataTime = val;
      this.findPage();
    },

    //翻页
    handleCurrentChange(val) {
      this.pageNum = val;
      this.findPage();
    },

    //查询护工组
    queryNurse() {
      this.$postForm("omc/group/selectShowAll").then((res) => {
        this.tabsList = res.result;
        this.groupId = res.result[0].id;
        this.findPage();
      });
    },

    //选项卡点击事件
    handleClick(tab, event) {
      let list = this.tabsList.filter((item) => {
        return item.name == tab.$attrs.value;
      });
      this.groupId = list[0].id;
      this.findPage();
    },

    //查询列表
    findPage() {
      if(this.datatime== ''){
        this.datatime = null;
      }
      let param = {
        date: this.datatime,
        nursingGroupId: this.groupId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.$postJson("omc/monitorlog/selectShowAlls", param).then((res) => {
        if (res.code == 200) {
          this.filterColumns = res.result.list;
          this.total = Number(res.result.total);
        } else {
          this.filterColumns = [];
        }
      });
    },

    // 分页刷新数据
    refreshPageRequest(data) {
      this.pageRequest.pageNum = data;
      this.findPage();
    },

    // 新增和编辑提交数据
    submitForm() {
      if (
        this.dataForm.oldName &&
        this.dataForm.date &&
        this.dataForm.responsibilityMan &&
        this.dataForm.timeHorizon &&
        this.dataForm.site &&
        this.dataForm.occurrence &&
        this.dataForm.reason &&
        this.dataForm.howToHandle
      ) {
        let param = {
          userName: this.dataForm.responsibilityMan,
          oldName: this.dataForm.oldName,
          id: this.fixLogid,
          oldManId: this.oldManId,
          userId: this.userId,
          period: this.dataForm.timeHorizon.join("-"),
          date: this.dataForm.date,
          place: this.dataForm.site,
          event: this.dataForm.occurrence,
          reason: this.dataForm.reason,
          handle: this.dataForm.howToHandle,
          nursingGroupId: this.groupId,
        };
        this.$postJson("omc/monitorlog/updateById", param).then((res) => {
          if (res.code == 200) {
            this.$message({ message: "修改成功", type: "success" });
            this.findPage(); //重新渲染页面
            this.$nextTick(() => {
              this.$refs["dataForm"].resetFields();
              this.dialogVisible = false; //关闭弹框
            });
          } else {
            this.$message({
              message: "修改失败, " + res.message,
              type: "error",
            });
          }
        });
      } else {
        this.$message({ message: "必填项不能为空", type: "error" });
      }
    },

    //修改日志
    fixLog(row) {
      //修改初始化
      this.dataForm = {
        oldName: row.oldName,
        date: row.date,
        responsibilityMan: row.userName, //负责人
        timeHorizon: row.period.split("-"), //时间范围
        site: row.place, //地点
        occurrence: row.event, //事件
        reason: row.reason, //原因
        howToHandle: row.handle, //如何处理
      };
      this.dialogVisible = true;
      this.fixLogid = row.id;
      this.oldManId = row.oldManId;
      this.userId = row.userId;
    },

    /* 
    模糊查询护士负责人
   */
    querynurse(queryString, cb) {
      let param = {
        oldName: this.dataForm.oldName,
        nursingGroupId: this.groupId,
      };
      this.$postJson("omc/monitorlog/selectUserByName", param).then((res) => {
        var list = [{}];
        if (res.result) {
          for (let i of res.result) {
            i.value = i.realName; //将想要展示的数据作为value
          }
          list = res.result;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
        }
      });
    },

    /* 
      根据负责人获取负责人id
    */
    SelectNurse(item) {
      this.userId = item.userId;
    },
    //删除当前列
    deleList(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: row.id,
          };
          this.$postForm("omc/monitorlog/mLogDelById", param).then((res) => {
            if (res.code == 200) {
              this.$message({ message: "删除成功", type: "success" });
              this.findPage(); //重新渲染页面
            } else {
              this.$message({
                message: "删除失败, " + res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
  created() {},
  mounted() {
    this.queryNurse();
  },
};
</script>
<style lang="scss" scoped>
.monitorlogmanagement {
  min-width: 1360px;
  min-height: 500px;
  background: #fefefe;
}
// ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
::v-deep .el-dialog .el-dialog__body {
  padding: 20px 20px 10px 20px !important;
}
.fenye{
  margin:20px
}
</style>
